module.exports = __webpack_public_path__ + "static/media/warn-red.c4399a31.svg";